module.exports = __webpack_public_path__ + "static/media/48.ea8e339c.JPG";